/**
 * Resumo de mudança num texto longo (as instruções do agente têm milhares de
 * caracteres): quantas linhas entraram e quantas saíram. Compara como
 * multiconjunto de linhas, então reordenar não conta como mudança e uma linha
 * editada aparece como "1 nova, 1 removida". É um resumo para o modal de
 * confirmação, não um diff para revisão.
 */
export function summarizeLineDiff(
  before: string,
  after: string
): { added: number; removed: number } {
  const count = (text: string) => {
    const lines = new Map<string, number>();
    for (const raw of text.split("\n")) {
      const line = raw.trim();
      if (!line) continue;
      lines.set(line, (lines.get(line) ?? 0) + 1);
    }
    return lines;
  };
  const previous = count(before);
  const next = count(after);
  let added = 0;
  let removed = 0;
  for (const [line, n] of next) {
    added += Math.max(0, n - (previous.get(line) ?? 0));
  }
  for (const [line, n] of previous) {
    removed += Math.max(0, n - (next.get(line) ?? 0));
  }
  return { added, removed };
}

/** "3 linhas novas, 1 removida" / "2 linhas alteradas" / "Ajustes no texto". */
export function describeLineDiff({
  added,
  removed,
}: {
  added: number;
  removed: number;
}): string {
  if (added === 0 && removed === 0) return "Ajustes no texto";
  if (added === removed) {
    return `${added} ${added === 1 ? "linha alterada" : "linhas alteradas"}`;
  }
  const parts: string[] = [];
  if (added > 0) {
    parts.push(`${added} ${added === 1 ? "linha nova" : "linhas novas"}`);
  }
  if (removed > 0) {
    parts.push(`${removed} ${removed === 1 ? "removida" : "removidas"}`);
  }
  return parts.join(", ");
}
